.statusCell {
  display: flex;
  align-items: center;
  gap: 0.5em;
}
